// import axios from 'axios';
import Cookie from '@/utils/cookie'
import message from 'ant-design-vue/lib/message'
import 'ant-design-vue/lib/message/style'
import Context from '@/utils/context'
import request from '@/utils/request'

class User {
  constructor () {
  }

  static deleteUpiAndBank (id) {
    return request
      .post(`/landscape/withdraw/bankAccountController/delete`, { id: id })
      .then(res => {
        console.log('deleteUpiAndBank', res.data)
        if (res.data.code == 0) {
          return Promise.resolve(res.data)
        } else {
          message.error({
            content: 'Something went wrong with server, please retry later.'
          })

        }
      })
      .catch(err => {
        console.log('saveOrUpdateUpiAndBank', err)
        message.error({
          message: 'Something went wrong with server, please retry later.'
        })
        return Promise.reject(err)
      })
  }

  //
  static saveOrUpdateUpiAndBank (id, userId, upiAccountNumber, bankAccountNumber, bankAccountHolderName, accountIfscCode, mobile, createTime) {
    return request
      .post(`/landscape/withdraw/bankAccountController/saveOrUpdate`, {
        id: id,
        userId: userId,
        upiAccountNumber: upiAccountNumber,
        bankAccountNumber: bankAccountNumber,
        bankAccountHolderName: bankAccountHolderName,
        accountIfscCode: accountIfscCode,
        mobile: mobile,
        createTime: createTime
      })
      .then(res => {
        console.log('saveOrUpdateUpiAndBank', res.data)
        if (res.data.code == 0) {
          return Promise.resolve(res.data)
        } else {
          message.error({
            content: 'Something went wrong with server, please retry later.'
          })

        }
      })
      .catch(err => {
        console.log('error', err)
        console.log('saveOrUpdateUpiAndBank', err)
        message.error({
          message: 'Something went wrong with server, please retry later.'
        })
        return Promise.reject(err)
      })
  }

  //
  static queryUpiAndBank () {
    return request
      .post(`/landscape/withdraw/bankAccountController/query`)
      .then(res => {
        console.log('queryUpiAndBank', res.data)
        if (res.data.code == 0) {

          return Promise.resolve(res.data)
        } else {

          message.error({
            content: 'Something went wrong with server, please retry later.'
          })

        }
      })
      .catch(err => {
        console.log('queryUpiAndBank', err)
        message.error({
          message: 'Something went wrong with server, please retry later.'
        })
        return Promise.reject(err)
      })
  }

  static verify (mobile) {
    return request(`/region/user/get_verify_code?mobile=${mobile}`, {})
      .then(res => {
        if (res.data.code === 0) {
          message.info({
            content: 'Verify code was sent to your phone number'
          })
          return Promise.resolve(res.data.data)
        } else if (res.data.code === 413) {
          message.error({
            content: 'No chance to obtain OTP today. Please try it after 24 hours.'
          })
          return Promise.reject(res.data)
        } else if (res.data.code === 400) {
          message.error({
            content: 'Send too many sms, please wait a momnt or use another phone number.'
          })
          return Promise.reject(res.data)
        } else if (res.data.code === 409) {
          message.error({
            content: 'This phone number is used. Go to login or use another.'
          })
          return Promise.reject(res.data)
        } else if (res.data.code === 422) {
          message.error({
            content: 'Failed to send verify code sms, please check your phone number and retry.'
          })
          return Promise.reject(res.data)
        }
      })
      .catch(err => {
        console.log(err)
        return Promise.reject(err)
      })
  }

  static doVerify (mobile, code, uid, aid) {
    return request(`/landscape/user/verify?mobile=${mobile}&code=${code}&uid=${uid}&aid=${aid}`, {}).then(res => {
      console.log(res.data)
      if (res.data.code == 0) {
        if (res.data.token) {
          Cookie.setCookie('token', res.data.token)
        }
        // let userId = JSON.parse(atob(res.data.data.token.split('.')[1]));
        return Promise.resolve(res.data.user)
      } else if (res.data.code == 401) {
        message.error({
          content: 'Your verify code mismatch with phone numer'
        })
        return Promise.reject(res.data)
      } else if (res.data.code == 403) {
        message.error({
          content: 'Your verify code is not correct'
        })
        return Promise.reject(res.data)
      } else if (res.data.code == 409) {
        console.log('err 409')
        message.error({
          content: 'This phone numer mismatch with your account!'
        })
        return Promise.reject(res.data)
      } else {
        message.error({
          content: 'Something went wrong with server, please retry later.'
        })
        return Promise.reject(res.data)
      }
    })
  }

  static signup (mobile, password, verifyCode) {
    let aid = Context.getAid()
    let label = Context.getLabel()
    return request('/landscape/user/register', {
      method: 'POST',
      data: {
        mobile,
        password,
        verifyCode,
        aid,
        label
      }
    }).then(res => {
      if (res.data.code === 0) {
        Cookie.setCookie('token', res.data.data.token)
        let userId = JSON.parse(atob(res.data.data.token.split('.')[1]))
        return Promise.resolve(userId)
      } else if (res.data.code === 401) {
        message.error({
          content: 'Your verify code mismatch with phone numer'
        })
        return Promise.reject(res.data)
      } else if (res.data.code === 409) {
        message.error({
          content: 'This phone numer has been registered!'
        })
        return Promise.reject(res.data)
      } else {
        message.error({
          content: 'Something went wrong with server, please retry later.'
        })
        return Promise.reject(res.data)
      }
    })
  }

  static logout () {
    Cookie.deleteCookie('token')
  }

  static hasLogin () {
    // return Promise.resolve('test');
    console.log('check wether login')
    let region = 'US'
    return request('/region/user/info?region=' + region).then(res => {
      if (res.data.code === 0) {
        Cookie.setCookie('token', res.data.token)
        return Promise.resolve(res.data.data)
      } else {
        return Promise.resolve('')
      }
    }).catch(err => {
      console.log(err)
      return Promise.resolve('')
    })
  }

  static info (id, uid, aid, channelid, pkg, extra) {
    let source = (channelid && pkg && channelid != '3100003') ? 'other_channel' : ''
    console.log('get user info, aid::' + aid + ', uid::' + uid)
    return request(`/region/vgi/index?id=${id}&uid=${uid}&aid=${aid}&channelid=${channelid}&pkg=${pkg}&source=${source}&extra=${extra}`, {}).then(res => {
      if (res.data.code === 0) {
        if (res.data.token) {
          Cookie.setCookie('token', res.data.token)
        }
        localStorage.setItem('vg_aid', res.data.data.aid || aid || '')
        localStorage.setItem('vg_uid', res.data.data.uid || uid || '')
        return Promise.resolve(res.data)
      } else {
        return Promise.reject(res.data)
      }
    })
  }

  static withdrawCashfreeApi (params) {
    return request('/landscape/withdraw/cashfree/api/payout', {
      method: 'POST',
      data: params
    }).then(res => {
      console.log(res)
      if (res.data.code === 0) {
        message.info({
          content: 'The withdrawal has been successful and money will be sent to you within 7 working days.'
        })
        return Promise.resolve(res.data.data)
      } else if (res.data.code === 400) {
        message.error({
          content: 'The system is upgrading, please try later.'
        })
        return Promise.reject(res.data)
      } else if (res.data.code === 411) {
        message.error({
          content: 'At least 1000 can be withdrawn'
        })
        return Promise.reject(res.data)
      } else if (res.data.code === 413) {
        message.error({
          content: 'At most 1 withdraw in 24 hours'
        })
        return Promise.reject(res.data)
      } else if (res.data.code === 422) {
        message.error({
          content: 'Something went wrong with server, please retry later.'
        })
        return Promise.reject(res.data)
      } else if (res.data.code === 500) {
        message.error({

          content: 'Banking services are busy, please try again later.'
        })
        return Promise.reject(res.data)
      }
    })
  }

  static withdrawCheck () {
    return request('/landscape/withdraw/check', {
      method: 'POST',
      data: {}
    })
      .then(res => {
        if (res.data.code === 0) {
          return Promise.resolve(res.data)
        } else {
          return Promise.reject(res.data)
        }
      })
      .catch(err => {
        console.log(err)
      })
  }

  static withdrawDetail (params) {
    return request('/landscape/withdraw/withdrawDetail', {
      method: 'POST',
      data: params
    }).then(res => {
      if (res.data.code === 0) {
        return Promise.resolve(res.data)
      } else {
        return Promise.reject(res.data)
      }
    })
      .catch(err => {
        console.log(err)
      })
  }

  static promptLogin () {
    return true
    // let lastPrompt = parseInt(localStorage.getItem('prompt_guest_sign') || '0');
    // let now = new Date().getTime();
    // if (lastPrompt != 0 && lastPrompt < now - 24 * 3600 * 1000) {
    //     localStorage.setItem('prompt_guest_sign', now);
    //     return true;
    // }
    // return false;
  }

  static rewards (count) {
    // console.log(count);
    // return Promise.resolve([{"amount":240,"num":19,"name":"***mwqk"},{"amount":316,"num":17,"name":"***oyaz"},{"amount":335,"num":21,"name":"***p4l9"},{"amount":180,"num":10,"name":"***o0ac"},{"amount":197,"num":15,"name":"***msp2"},{"amount":105,"num":7,"name":"***kjeu"},{"amount":226,"num":9,"name":"***7us8"},{"amount":418,"num":22,"name":"***jr1v"},{"amount":188,"num":5,"name":"***b68x"},{"amount":285,"num":22,"name":"***0dar"},{"amount":384,"num":22,"name":"***oxmj"},{"amount":340,"num":20,"name":"***0agf"},{"amount":227,"num":5,"name":"***ukjr"},{"amount":179,"num":10,"name":"***uu5x"},{"amount":142,"num":8,"name":"***17xq"},{"amount":436,"num":23,"name":"***rxre"},{"amount":206,"num":7,"name":"***0xp2"},{"amount":306,"num":16,"name":"***djxd"},{"amount":174,"num":5,"name":"***p3vz"},{"amount":167,"num":15,"name":"***tu5h"},{"amount":303,"num":15,"name":"***af8t"},{"amount":323,"num":22,"name":"***fmdj"},{"amount":297,"num":20,"name":"***b91e"},{"amount":260,"num":15,"name":"***60o3"},{"amount":247,"num":21,"name":"***ma4a"},{"amount":345,"num":24,"name":"***45g6"},{"amount":216,"num":17,"name":"***layu"},{"amount":308,"num":11,"name":"***z4se"},{"amount":283,"num":21,"name":"***ueye"},{"amount":241,"num":12,"name":"***w6ke"},{"amount":237,"num":13,"name":"***p1kd"},{"amount":320,"num":14,"name":"***3rl3"},{"amount":249,"num":11,"name":"***5707"},{"amount":122,"num":11,"name":"***1b04"},{"amount":63,"num":5,"name":"***eg4d"},{"amount":141,"num":7,"name":"***mgu4"},{"amount":288,"num":11,"name":"***ofy5"},{"amount":325,"num":18,"name":"***mrp2"},{"amount":138,"num":6,"name":"***jcg8"},{"amount":251,"num":19,"name":"***iphy"},{"amount":306,"num":12,"name":"***4fuv"},{"amount":218,"num":13,"name":"***4prr"},{"amount":307,"num":17,"name":"***fgyl"},{"amount":162,"num":12,"name":"***aa67"},{"amount":189,"num":11,"name":"***dgts"},{"amount":261,"num":16,"name":"***f1zh"},{"amount":377,"num":19,"name":"***3pi9"},{"amount":197,"num":15,"name":"***tleo"},{"amount":317,"num":16,"name":"***d0tx"},{"amount":284,"num":24,"name":"***8pm4"}]);
    count = count || 100
    return request(`/app/user/rewards?count=${count}`).then(res => {
      if (res.data.code === 0) {
        return Promise.resolve(res.data.data)
      } else {
        return Promise.reject(res.data)
      }
    })
  }

  static affiliates (keyword) {
    let aid = localStorage.getItem('vg_aid') || ''
    let uid = localStorage.getItem('vg_uid') || ''
    return request(`/landscape/dealer/affilites?keyword=${keyword}&aid=${aid}&uid=${uid}`, { method: 'GET' }).then(res => {
      if (res.data.code === 0) {
        return Promise.resolve(res.data)
      } else {
        return Promise.resolve([])
      }
    })
  }

  static getVungoUserByUid (uid) {
    return request(`/landscape/user/vungo_user?uid=${uid}`, { method: 'GET' }).then(res => {
      if (res.data.code === 0) {
        return Promise.resolve(res.data.data)
      } else {
        return Promise.resolve(null)
      }
    })
  }

}

export default User
